import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dLayerLoadedPartialReducer: IPartialReducer<Wfs3dLayersState> = () => {
    return {
        loading: false,
    };
};
